import { createContext, useCallback, useContext, useState } from "react";

// Small context to let the sticky Navbar trigger the MobileDrawer, which
// itself lives at the Layout root (outside the navbar's sticky stacking
// context so `fixed inset-0` actually fills the viewport instead of being
// clipped to the 64px navbar row).
const UiChromeContext = createContext({ drawerOpen: false, openDrawer: () => {}, closeDrawer: () => {} });

export function UiChromeProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const openDrawer = useCallback(() => setDrawerOpen(true), []);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);
  return (
    <UiChromeContext.Provider value={{ drawerOpen, openDrawer, closeDrawer }}>
      {children}
    </UiChromeContext.Provider>
  );
}

export const useUiChrome = () => useContext(UiChromeContext);
